export default __webpack_public_path__ + "static/media/Persona_con_caja.94f608a8.png";